import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TYPOGRAPHY_H4 } from '../styles/typography/typography';
import { PROMETHEAN_ERROR_OR_DESTRUCT, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_NEUTRAL_GREY_700, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_BLUE, PROMETHEAN_TEXT_HEADER } from '../styles/colors/colors';
var StyledCodeInput = styled('div')(function () {
  return {
    '.EmbersCodeInput-status': {
      marginTop: 4,
      '.EmbersStatusIcon-icon': {
        cursor: 'default'
      }
    },
    '.EmberCodeInput-hideCursor': {
      caretColor: 'transparent'
    },
    '.EmbersCodeInput-input': {
      position: 'relative',
      display: 'flex',
      '& .EmbersCodeInput-item': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_H4), {}, {
        color: PROMETHEAN_TEXT_HEADER,
        WebkitAppearance: 'none',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: '8px',
        backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: 36,
        height: 48,
        marginRight: 8,
        padding: 0,
        textTransform: 'uppercase',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        '&:not(.EmbersCodeInput-item-invalid, .EmbersCodeInput-item-disabled)': {
          borderColor: PROMETHEAN_NEUTRAL_GREY_700
        },
        '&:last-child': {
          marginRight: 0
        },
        '&.EmbersCodeInput-item-invalid': {
          borderColor: PROMETHEAN_ERROR_OR_DESTRUCT,
          '&:not(.EmbersCodeInput-item-clickFocus)': {
            '&:focus-visible': {
              outline: "1px solid ".concat(PROMETHEAN_ERROR_OR_DESTRUCT),
              outlineOffset: -4
            }
          }
        },
        '&.EmbersCodeInput-item-disabled': {
          borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
          color: PROMETHEAN_NEUTRAL_DARK_GREY
        },
        '&:focus': {
          border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
          outline: 'none'
        },
        '&:not(.EmbersCodeInput-item-clickFocus)': {
          '&:focus-visible': {
            border: "2px solid ".concat(PROMETHEAN_BLUE),
            outline: 'none'
          }
        },
        '&-clickFocus': {
          '&:focus-visible': {
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
            outline: 'none'
          }
        }
      })
    },
    '&.EmbersCodeInput-dark': {
      '.EmbersCodeInput-status-dark': {
        marginTop: 12,
        marginLeft: 10
      },
      '.EmbersCodeInput-item': {
        borderWidth: 2,
        '&:not(.EmbersCodeInput-item-invalid, .EmbersCodeInput-item-disabled)': {
          borderColor: '#A19ABA'
        },
        '&-clickFocus': {
          '&:focus-visible': {
            border: "2px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          }
        },
        '&:not(.EmbersCodeInput-item-clickFocus)': {
          '&:focus-visible': {
            border: "2px solid ".concat(PROMETHEAN_NEUTRAL_WHITE),
            boxShadow: "inset 0 0 0 1px ".concat(PROMETHEAN_PURPLE_GRAPE)
          }
        },
        '&.EmbersCodeInput-item-invalid': {
          '&:not(.EmbersCodeInput-item-disabled)': {
            borderColor: PROMETHEAN_ERROR_OR_DESTRUCT
          },
          '&:not(.EmbersCodeInput-item-clickFocus)': {
            '&:focus-visible': {
              border: "2px solid ".concat(PROMETHEAN_NEUTRAL_WHITE),
              boxShadow: "inset 0 0 0 1px ".concat(PROMETHEAN_ERROR_OR_DESTRUCT),
              outline: 0
            }
          }
        }
      }
    }
  };
});
export default StyledCodeInput;